import { Injectable } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenInterceptorService implements HttpInterceptor {

  private rafraichissementEnCours = false;
  private nouveauTokenSubject = new BehaviorSubject<string | null>(null);

  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!request.url.startsWith(environment.api_LMS)) {

      return next.handle(request);
    }

    const utilisateur = this.authService.User;

    if (utilisateur != null && utilisateur.expired) {

      return this.gererErreur401(request, next);
    }

    const token = utilisateur?.access_token;
    const requeteAuthentifiee = token ? this.ajouterToken(request, token) : request;

    return next.handle(requeteAuthentifiee).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {

          return this.gererErreur401(request, next);
        }

        return throwError(() => error);
      })
    );
  }

  private ajouterToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }

  private gererErreur401(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.rafraichissementEnCours) {
      return this.nouveauTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(token => next.handle(this.ajouterToken(request, token!)))
      );
    }

    this.rafraichissementEnCours = true;
    this.nouveauTokenSubject.next(null);

    return this.authService.refreshToken().pipe(
      switchMap(nouveauToken => {
        this.rafraichissementEnCours = false;
        this.nouveauTokenSubject.next(nouveauToken);
        return next.handle(this.ajouterToken(request, nouveauToken));
      }),
      catchError(error => {
        this.rafraichissementEnCours = false;
        this.authService.logoutToLogin();
        return throwError(() => error);
      })
    );
  }
}
